import { render, staticRenderFns } from "./catalog.vue?vue&type=template&id=55e6744c&"
import script from "./catalog.vue?vue&type=script&lang=ts&"
export * from "./catalog.vue?vue&type=script&lang=ts&"
import style0 from "./catalog.vue?vue&type=style&index=0&lang=postcss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports